import { FC } from 'react';
import styles from './styles/CheckoutSidebarItemInfoShimmer.scss';

export const CheckoutSidebarItemInfoShimmer: FC = () => {
    return (
        <div data-tn="checkout-shimmer" className={styles.container}>
            <div className={styles.image} />
            <div className={styles.blockContainer}>
                <div className={styles.block} />
                <div className={styles.block} />
                <div className={styles.block} />
            </div>
        </div>
    );
};
